<template>
    <NavigationForm />
  </template>
  
  <script>
  import NavigationForm from "@/components/navigation/NavigationForm.vue";
  
  export default {
    name: "NavigationCreatePage",
    components: {
      NavigationForm,
    },
  };
  </script>
  